
import moment from 'moment';
import { ColorService, ValidatorsService } from '@app/services';
import { Ambassador, Language, LanguagesTexts } from '@app/models'

export class OperationGender {
    label: string;
    value: string;
}

export class OperationProduct {
    label: string;
    value: string;
    picture: string;
}

export class OperationMenu {
    id: string;
    label: string;
    route: string;
}

export class OperationStory {
    ID: string;
    url: string;
    urlThumbnail: string;
    order: number;
    type: 'image'|'video';
    viewed: boolean = false;
    
    constructor(ID: string, url: string, urlThumbnail: string, order: number, type: 'image'|'video' = 'video'){
        this.ID = ID;
        this.url = url;
        this.urlThumbnail = urlThumbnail;
        this.order = order;
        this.type = type;
    }
}

export class OperationNewsLike {
    ambassadorID: string
    date: string
}

export class OperationNews {
    ID: string;
    title: string;
    titles: LanguagesTexts;
    description: string;
    descriptions: LanguagesTexts;
    url: string;
    urlThumbnail: string;    
    startDate: string|null;
    endDate: string|null;
    onTop: boolean;
    likes: Array<OperationNewsLike>;
    type: 'image'|'video';
    
    constructor(ID: string, title: string, titles: LanguagesTexts, description: string, descriptions: LanguagesTexts, url: string, urlThumbnail: string, startDate: string|null, endDate: string|null, onTop: boolean, likes: Array<OperationNewsLike>, type: 'image'|'video' = 'video'){
        this.ID = ID;
        this.title = title;
        this.titles = titles;
        this.description = description;
        this.descriptions = descriptions;
        this.url = url;
        this.urlThumbnail = urlThumbnail;
        this.startDate = startDate;
        this.endDate = endDate;
        this.onTop = onTop;
        this.likes = likes;
        this.type = type;
    }
}

export class OperationFaq {    
    title: string;
    titleCleaned: string;
    subtitle: string;
    subtitleCleaned: string;
    description: string;
    descriptionCleaned: string;
    media: string;
    mediaThumbnail: string;
    button: string;
    buttonLink: string;
    buttonSeeMore: string;
    order: number;
}

export class OperationShopProductLevel {
    id: number;
    label: string;
}

export class OperationShopProduct {
    ID: string;
    title: string;
    description: string;
    media: string|null;
    level: OperationShopProductLevel|null;
    quantity: number;
    quantityMaxPerAmbassador: number;
    quantityAlreadyOrdered: number;
    costInPoints: number;
    isEnabled: boolean;
    order: number;
    availabilty: number;
}

export class OperationShop {
    isEnabled: boolean = false;
    products: Array<OperationShopProduct> = [];
}

export class Operation {
    
    value: any = null;
    constructor(value: any = null){
        if(value){
            
            let primaryColor = value.pwa?.style?.theme?.mainColor;
            if(primaryColor){
                value.pwa.style.theme.mainColor = ColorService.parseRGBStr(primaryColor).join(',');
            }
            let secondaryColor = value.pwa?.style?.theme?.secondaryColor;
            if(secondaryColor){
                value.pwa.style.theme.secondaryColor = ColorService.parseRGBStr(secondaryColor).join(',');
            }
            
            let buttonBackgroundColor = value.pwa?.style?.common?.button?.backgroundColor;
            if(buttonBackgroundColor){
                value.pwa.style.common.button.backgroundColor = ColorService.parseRGBStr(buttonBackgroundColor).join(',');
            }
            let buttonTextColor = value.pwa?.style?.common?.button?.color;
            if(buttonTextColor){
                value.pwa.style.common.button.color = ColorService.parseRGBStr(buttonTextColor).join(',');
            }
            
            value._medias = (value?.pwa?.media || []).map((m: any) => {
                m.URL = m.URL.replace(/^http:/, 'https:');
                return m;
            });
            
            let tabStories: Array<OperationStory> = [];
            value.pwa?.content?.home?.storyMediaIDs?.forEach((story: any) => {   
            
                let now =  moment().format('YYYY-MM-DD');
                let startDate = (story.startDate && story.startDate != '' ? story.startDate : moment().format('YYYY-MM-DD'));
                let endDate = (story.endDate && story.endDate != '' ? story.endDate : moment().format('YYYY-MM-DD'));
            
                if(startDate <= now && now <= endDate){
                    let urlMedia = value.pwa?.media?.find((e: any) => e.ID === story.media)?.URL;
                    let typeMedia: 'image'|'video' = (urlMedia.match(/(.mov|.mp4)$/) !== null ? 'video' : 'image');
                    let s = new OperationStory (     
                        story.ID,
                        urlMedia,
                        value.pwa?.media?.find((e: any) => e.ID === story.mediaThumbnail)?.URL,
                        story.order,
                        typeMedia
                    );
                    if(!s.urlThumbnail){
                        if(s.type === 'image'){
                            s.urlThumbnail = s.url;
                        }
                        else{
                            s.urlThumbnail = s.url?.replace('.mov', '.jpg').replace('.mp4', '.jpg').replace('upload/', 'upload/w_400,h_300,c_fill,g_face/');
                        }                    
                    }
                    tabStories.push(s);
                }
            });  
            value._stories = tabStories;
              
            let tabNews: Array<OperationNews> = [];
            value.pwa?.content?.news?.forEach((news: any) => {   
            
                let now =  moment().format('YYYY-MM-DD');
                let startDate = (news.startDate && news.startDate != '' ? news.startDate : moment().format('YYYY-MM-DD'));
                let endDate = (news.endDate && news.endDate != '' ? news.endDate : moment().format('YYYY-MM-DD'));
            
                if(news.isEnabled && startDate <= now && now <= endDate){            
                    let urlMedia = value.pwa?.media?.find((e: any) => e.ID === news.media)?.URL;
                    let typeMedia: 'image'|'video' = (urlMedia && urlMedia.match(/(.mov|.mp4)$/) !== null ? 'video' : 'image');     
                    let n = new OperationNews (     
                        news.ID,
                        news.title,
                        new LanguagesTexts(news.titles),
                        news.description,
                        new LanguagesTexts(news.descriptions),
                        urlMedia,
                        value.pwa?.media?.find((e: any) => e.ID === news.mediaThumbnail)?.URL,
                        (news.startDate && news.startDate != '' ? news.startDate : null),
                        (news.endDate && news.endDate != '' ? news.endDate : null),
                        news.onTop,
                        news.likes,
                        typeMedia                    
                    );
                    if(!n.urlThumbnail){
                        if(n.type === 'image'){
                            n.urlThumbnail = n.url;
                        }
                        else{
                            n.urlThumbnail = n.url?.replace('.mov', '.jpg').replace('.mp4', '.jpg').replace('upload/', 'upload/w_400,h_300,c_fill,g_face/');
                        }   
                    }
                    tabNews.push(n);
                }
            }); 
            
            tabNews.sort((a, b) => {
                let order = 0;
                if(a.onTop && !b.onTop){
                    return -1;
                }
                else if(!a.onTop && b.onTop){
                    return 1;
                }
                else if(a.startDate !== null && b.startDate !== null){
                    if(a.startDate > b.startDate){
                        return -1;
                    }
                    else if (a.startDate < b.startDate){
                        return 1;
                    }
                }
                else if(a.startDate !== null){
                    return -1;
                }
                else if(b.startDate !== null){
                    return 1;
                }               
                return order;                
            });
                        
            value._news = tabNews;
            
            let shop = new OperationShop();
            if(value.shop && value.shop.isEnabled){
                shop.isEnabled = true;
                let products: Array<OperationShopProduct> = [];
                value.shop.products.forEach((product: any) => {
                    if(product.isEnabled){
                        let level = value.challenges?.levels[product.level] || null;
                        product.media = value.pwa?.media?.find((e: any) => e.ID === product.media)?.URL;
                        product.level = (level ? {id: product.level, label: level.name} : null);                        
                        products.push(product);
                    }
                });
                products.sort((a, b) => (a.order || 0) - (b.order || 0));
                shop.products = products;
            }
            value._shop = shop;
        }
        this.value = value;        
    }
    
    get media(): Array<any> {
        return this.value?._medias || [];
    }
    
    get settings(): any | undefined {
        return this.value?.settings;
    }
    
    get style(): any | undefined {
        return this.value?.pwa?.style;
    }
    
    get signupContent(): any | undefined {
        return this.value?.pwa?.content?.authentication?.signup;
    }
    
    get settingsContent(): any | undefined {
        return this.value?.pwa?.content?.settings;
    }
        
    get commonContent(): any | undefined {
        return this.value?.pwa?.content?.common;
    }
    
    get homeContent(): any | undefined {
        return this.value?.pwa?.content?.home;
    }
    
    get validateMatchContent(): any | undefined {
        return this.value?.pwa?.content?.validateMatch;
    }
    
    get salesContent(): any | undefined {
        return this.value?.pwa?.content?.sales;
    }
    
    get demonstrationsContent(): any | undefined {
        return this.value?.pwa?.content?.demonstrations;
    }
    
    get questionsContent(): any | undefined {
        return this.value?.pwa?.content?.questions;
    }
    
    get sponsorContent(): any | undefined {
        return this.value?.pwa?.content?.sponsor;
    }
    
    get communications(): any | undefined {
        return this.value?.communications;
    }
    
    get levels(): any {
        return this.value?.challenges?.levels || [];
    }
    
    get hasMissions(): boolean {
        return this.levels.length > 0 
            || (this.value?.challenges?.missions || []).length > 0 
            || (this.value?.challenges?.flash || []).length > 0; 
    }
    
    get lightLogo(): string|undefined {
        return this.media.find((m: any) => m.ID === this.value?.pwa?.content?.logo?.lightLogoMediaID)?.URL
    }
    
    get darkLogo(): string|undefined {
        return this.media.find((m: any) => m.ID === this.value?.pwa?.content?.logo?.darkLogoMediaID)?.URL;
    }
    
    get pwaLogo(): string|undefined {
        return this.media.find((m: any) => m.ID === this.value?.pwa?.content?.logo?.pwaLogoMediaID)?.URL;
    }
    
    get homeThumbnailMedia(): string|undefined {
        return this.media.find((m: any) => m.ID === this.value?.pwa?.content?.home?.homeThumbnailMediaID)?.URL;
    }
    
    get homeMedia(): string|undefined {
        return this.media.find((m: any) => m.ID === this.value?.pwa?.content?.home?.homeMediaID)?.URL;
    }
    
    get stories(): Array<OperationStory> {
        return this.value?._stories || [];
    }
    
    get news(): Array<OperationNews> {
        return this.value?._news || [];
    }
    
    get shop(): OperationShop {
        return this.value?._shop || new OperationShop();
    }
    
    get faq(): Array<OperationFaq> {
        return this.value?.faq?.filter( (f: OperationFaq) => {
                return f.title !== '(new)';
            })?.map( (f: OperationFaq) => {
                let newFaq = {...f};
                newFaq.titleCleaned = ValidatorsService.CleanString(f.title);
                newFaq.subtitleCleaned = ValidatorsService.CleanString(f.subtitle);
                newFaq.descriptionCleaned = ValidatorsService.CleanString(f.description);
                newFaq.media = this.media.find((m: any) => m.ID === f.media)?.URL;
                newFaq.mediaThumbnail = this.media.find((m: any) => m.ID === f.mediaThumbnail)?.URL;
                if(!newFaq.mediaThumbnail || newFaq.mediaThumbnail == ''){
                    if(newFaq.media && newFaq.media != ''){
                        newFaq.mediaThumbnail = newFaq.media.replace(/(\.mov)|(\.mp4)/gi, '.jpg');
                    }
                    else{
                        newFaq.mediaThumbnail = this.media.find((m: any) => m.ID === this.homeContent?.manual?.iconMediaID)?.URL;
                    }
                }
                return newFaq;
            })?.sort((a: OperationFaq, b: OperationFaq) => {
                let aOrder = (a.order ? a.order : 0);
                let bOrder = (b.order ? b.order : 0);
                return (aOrder > bOrder ? 1 : (aOrder < bOrder ? -1 : 0));     
            }) || [];
    }
    
    get languages(): Array<Language> {
        let languages: Array<Language> = [];
        this.value?.pwa?.languages?.forEach((l: any) => {
            languages.push({
                ID: l.language.ID,
                name: l.language.name, 
                shortCode: l.language.shortCode
            });
        });
        languages.sort((a,b) => a.name.localeCompare(b.name));
        return languages;
    }    
    
    getGenders(): Array<OperationGender> {            
         return [
            {label: 'GENDER.MALE', value: 'male'},
            {label: 'GENDER.FEMALE', value: 'female'},
            {label: 'GENDER.OTHER', value: 'other'}
        ];       
    }
    
    getCivilityLabel(gender: string): string {
        let civility: string = '';
        switch (gender) {
            case 'male':
                return 'CIVILITY.MALE';
            case 'female':
              return 'CIVILITY.FEMALE';                        
        }
        return civility;
    }
    
    getProducts(productIDs: Array<string> = []): Array<OperationProduct>{
        let products: Array<OperationProduct> = [];
        if(this.value?.products){
            for(let p of this.value.products){
                if(productIDs.length === 0 || productIDs.indexOf(p.ID) !== -1){
                    products.push({
                        value: p.ID,
                        label: p.name,
                        picture: p.pictureURI                    
                    });
                }
            }
        }
        return products;
    }
    
    getMenu(): Array<OperationMenu> {        
        let menus = [
            {id: 'home',route: 'home', label: 'MENU.HOME'}
        ];
        
        if(this.hasMissions){
            menus.push({id: 'missions', route: 'missions', label: 'MENU.MISSIONS'});            
            if(this.shop.isEnabled){
                menus.push({id: 'shop', route: 'shop', label: 'MENU.SHOP'});
            }
            menus.push({id: 'community', route: 'community', label: 'MENU.COMMUNITY'});
        }
        
        menus.push({id: 'settings', route: 'settings', label: 'MENU.SETTINGS'});     
        
        return menus;
    }
    
    getLevel(numLevel: number): any|undefined{
        let level: any|undefined = undefined;
        if(numLevel >= 0 && this.levels?.length > 0){
            level = this.levels[numLevel];
        }
        return level;
    }
    
    getStoriesSorted(ambassador: Ambassador): Array<OperationStory>{
        let stories = this.stories;       
        for(let story of stories){
            story.viewed = ambassador.value?.pwaAnalytics?.stories?.find((s: any) => s.storyID === story.ID);
        }
        stories.sort((a: OperationStory, b: OperationStory) => {
            if(a.viewed){
                return 1;
            }
            else if (b.viewed){
                return -1;
            }
            else{
                let aOrder = (a.order ? a.order : 0);
                let bOrder = (b.order ? b.order : 0);
                return (aOrder > bOrder ? 1 : (aOrder < bOrder ? -1 : 0));     
            }
        });
        return stories;
    }
}
